// $('.c-searchCourse-category-item__body-item').click(function () {
//   $(this).toggleClass('is-current');
// });